import {Box, HStack, Icon, Text, VStack} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

interface BpmUnavailableProps extends TestIdProps {
  title: string;
  message: string;
  variant?: 'neutral' | 'warning';
}

/**
 * Explains why the estimate is missing or cannot be fully trusted. Deliberately
 * not a platform Alert, which would outweigh the estimate inside the grey block.
 */
export function BpmUnavailable(props: BpmUnavailableProps) {
  const isWarning = props.variant === 'warning';

  return (
    <Box
      backgroundColor={isWarning ? 'palettes.orange.20.100' : 'general.white'}
      borderRadius="small"
      padding={3}
      data-testid={suffixTestId('bpmNotice', props)}
    >
      <HStack spacing={2} align="flex-start">
        <Icon
          value={isWarning ? 'alert/warning' : 'action/info_outline'}
          size={4}
          color={isWarning ? 'severity.warning' : 'text.secondary'}
        />
        <VStack spacing={1}>
          <Text size="xSmall" alternative>
            {props.title}
          </Text>
          <Text size="xSmall" color="secondary">
            {props.message}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
}
